var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 12,
    viewBox: "0 0 3 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.19881 8.4C0.88276 8.4 0.579658 8.27357 0.356178 8.04853C0.132699 7.82348 0.00714943 7.51826 0.00714943 7.2L0.0166831 1.2C0.0166831 0.88174 0.142232 0.576516 0.365711 0.351472C0.58919 0.126428 0.892294 0 1.20834 0C1.52439 0 1.82749 0.126428 2.05097 0.351472C2.27445 0.576516 2.4 0.88174 2.4 1.2L2.39047 7.2C2.39047 7.51826 2.26492 7.82348 2.04144 8.04853C1.81796 8.27357 1.51486 8.4 1.19881 8.4Z",
    fill: "#D19B07"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.19166 12C1.84979 12 2.38332 11.4627 2.38332 10.8C2.38332 10.1373 1.84979 9.6 1.19166 9.6C0.533524 9.6 0 10.1373 0 10.8C0 11.4627 0.533524 12 1.19166 12Z",
    fill: "#D19B07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.9957b09f79bbedb94c959c017bded7b4.svg";
export { ForwardRef as ReactComponent };